import { UserParticipationType } from "../../constants";

type InputWFInstanceMilestone = {
  id: string;
  sequence_no: number;
  name: string;
  actual_date: string;
};

type InputSubmittalLogItemMilestone = {
  id: string;
  sequence_no: number;
  name: string;
  actual: string;
};

function transformDataFromWFInstanceMilestones({
  workflow_instance_milestones
}: {
  workflow_instance_milestones: InputWFInstanceMilestone[];
}): {
  [key: number]: InputWFInstanceMilestone;
} {
  if (
    !workflow_instance_milestones ||
    workflow_instance_milestones.length === 0
  ) {
    return {};
  }

  return workflow_instance_milestones.reduce((acc: any, milestone: any) => {
    acc[milestone.sequence_no] = milestone;
    return acc;
  }, {});
}

function transformDataFromSubmittalLogItem(submittalLogItem: {
  date_block: {
    milestones: InputSubmittalLogItemMilestone[];
  };
}): { [key: number]: InputSubmittalLogItemMilestone } {
  const { milestones } = submittalLogItem.date_block;

  if (!milestones || milestones.length === 0) {
    return {};
  }

  return milestones.reduce((acc: any, milestone: any) => {
    acc[milestone.sequence_no] = {
      ...milestone,
      actual_date: milestone.actual
    };
    return acc;
  }, {});
}

function getUserFromParticipantType(submittalItem: any, typeId: number) {
  if (!submittalItem?.feature_user_paticipants) return null;

  const foundUser = submittalItem.feature_user_paticipants.find(
    (participant: any) => participant.user_participation_type_id === typeId
  );

  if (!foundUser) return null;

  const simplifiedUser = {
    id: foundUser?.user?.id,
    first_name: foundUser?.user?.first_name,
    last_name: foundUser?.user?.last_name,
    company: {
      name: foundUser?.user?.project_users[0]?.subscription_vendor?.name
    }
  };

  return simplifiedUser;
}

function getUserFromSubmittalLogItem(submittalLogItem: any, typeId: number) {
  if (!submittalLogItem) return null;

  const typeToKeysMap: any = {
    [UserParticipationType.SUBMITTER]: "submitter_reviewer",
    [UserParticipationType.GC_REVIEWER]: "gc_user",
    [UserParticipationType.DESIGN_REVIEWER]: "design_reviewer"
  };

  const key = typeToKeysMap[typeId];
  const foundUser = submittalLogItem[key];

  if (!foundUser) return null;

  const simplifiedUser = {
    id: foundUser?.id,
    first_name: foundUser?.first_name,
    last_name: foundUser?.last_name,
    company: foundUser?.company
  };

  return simplifiedUser;
}

function updateSubmittalLogItemHistory(
  submittalLogItem: any,
  projectParticipants: any
) {
  if (
    !submittalLogItem ||
    !submittalLogItem.history ||
    !projectParticipants?.allProjectUsersMap
  )
    return null;

  const updatedHistory = submittalLogItem.history.map((wfHistory: any) => {
    const missingHistoryData: any = {};
    if (wfHistory.assignee) {
      const assigneUser =
        projectParticipants.allProjectUsersMap[wfHistory.assignee];
      missingHistoryData.assignee_user = {
        id: wfHistory.assignee,
        email: assigneUser?.email || "",
        first_name: assigneUser?.first_name || "",
        last_name: assigneUser?.last_name || "",
        project_users: [
          {
            subscription_vendor: {
              name: assigneUser?.company?.name || ""
            }
          }
        ]
      };
    }
    if (wfHistory.on_behalf_of) {
      const onBehalfUser =
        projectParticipants.allProjectUsersMap[wfHistory.on_behalf_of];
      missingHistoryData.on_behalf_of_user = {
        id: wfHistory.on_behalf_of,
        email: onBehalfUser?.email || "",
        first_name: onBehalfUser?.first_name || "",
        last_name: onBehalfUser?.last_name || "",
        project_users: {
          subscription_vendor: {
            name: onBehalfUser?.company?.name || ""
          }
        }
      };
    }
    return {
      ...wfHistory,
      ...missingHistoryData
    };
  });

  return updatedHistory;
}

export {
  transformDataFromWFInstanceMilestones,
  transformDataFromSubmittalLogItem,
  getUserFromParticipantType,
  getUserFromSubmittalLogItem,
  updateSubmittalLogItemHistory
};
